import React, { useEffect, useState } from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { toast } from "react-toastify";
import { Field, Formik } from "formik";
import { SimpleSingleSelect } from "../../../../components/FormComponents/SimpleSingleSelect";
import { CTA } from "@coverme/forms";
import "../../../../styles/interview.scss";

export const InterviewSidebarTags = ({
    encounterTag,
    manualTags,
    tagOptions,
    automatedTags,
    encounterId,
    deleteTag,
    addTag,
    ...props
}) => {
    const [selectedTag, setSelectedTag] = useState(null);

    return (
        <InterviewSidebarSection title={`Tag`} {...props} expandable={false}>
            <Formik
                enableReinitialize={true}
                initialValues={{ encounterTag: encounterTag }}
                render={props => {
                    const { setFieldValue, setFieldTouched } = props;
                    return (
                        <form style={{ marginTop: "-40px" }}>
                            <div className="form-control l-input tags">
                                <Field
                                    name="encounterTag"
                                    render={({ field }) => (
                                        <SimpleSingleSelect
                                            {...field}
                                            id="encounterTag"
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            options={tagOptions}
                                            onFieldChange={value => {
                                                if (automatedTags?.filter(x => x.id != value)?.length > 0) {
                                                    if (automatedTags.filter(x => x.id == encounterTag)?.length > 0) {
                                                        let i = tagOptions.findIndex(x => x.value == encounterTag);
                                                        if (i >= 0) {
                                                            tagOptions.splice(i, 1);
                                                        }
                                                    }
                                                }
                                                setSelectedTag(value);
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="tagsSubmit">
                                <CTA
                                    size={"medium"}
                                    ctaType={"button"}
                                    styleType={"blue"}
                                    click={() => {
                                        if (selectedTag === "None") {
                                            deleteTag(encounterId).then(() => {
                                                toast.success("Tag removed successfully");
                                            });
                                        } else {
                                            addTag(encounterId, selectedTag).then(() => {
                                                toast.success("Tag added successfully");
                                            });
                                        }
                                    }}
                                >
                                    Save
                                </CTA>
                            </div>
                        </form>
                    );
                }}
            />
        </InterviewSidebarSection>
    );
};
